import { useAuth } from "@/lib/auth";
import { usePlatformDesigner } from "@/lib/usePlatformDesigner";
import { usePlatformDesignerBuyerPreview } from "@/lib/usePlatformDesignerBuyerPreview";
import { shouldHideBuyerTechnicalUi } from "@/lib/buyerConfigUi";

/**
 * ¿Mostrar configuración de sync automática SAT en formulario / pestaña Clientes?
 * Visible en modo diseñador BNT; oculto en modo comprador (SaaS o vista previa).
 */
export function canShowClientSatAutoSyncConfig(ctx = {}) {
  const {
    user = {},
    isPlatformDesigner = false,
    buyerPreviewUx = false,
    workspaceMode = "despacho",
    canSwitch = false,
    canGenerateLicenses = false,
  } = ctx;

  if (isPlatformDesigner && !buyerPreviewUx) return true;

  if (
    shouldHideBuyerTechnicalUi({
      user,
      workspaceMode,
      canSwitch,
      buyerPreviewUx,
      canGenerateLicenses,
    })
  ) {
    return false;
  }

  return false;
}

export function useCanShowClientSatAutoSyncConfig() {
  const { user } = useAuth();
  const isPlatformDesigner = usePlatformDesigner();
  const buyerPreviewActive = usePlatformDesignerBuyerPreview();

  return canShowClientSatAutoSyncConfig({
    user,
    isPlatformDesigner,
    buyerPreviewUx: buyerPreviewActive,
    canGenerateLicenses: Boolean(user?.can_generate_licenses),
  });
}
